import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	Button,
	useTheme,
	useMediaQuery
} from '@material-ui/core';

import AuthorizedUser from "../utils/AuthorizedUser";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";

function ViewPatternButton(props) {
	const theme = useTheme();
	const isSm = useMediaQuery(theme.breakpoints.up("sm"));
	const authenticatedUser = useContext(AuthorizedUserContext);

	let {pattern, className, history, title, link, icon} = props,
		hasPatterns = AuthorizedUser.hasPatterns(authenticatedUser),
		{patternId, status} = pattern || {};

	if (!link) {
		link = `/patterns/${status}/${patternId}`;
	}

	return hasPatterns && patternId && isSm ? (
		<Button
			color="primary"
			className={className}
			onClick={() => history.push(link)}
			startIcon={icon ?
				<FontAwesomeIcon
					title={title}
					icon={["fad", "braille"]} /> : null
			}>
			{title}
		</Button>
	) : null;
}

ViewPatternButton.defaultProps = {
	icon: true,
	title: "View Pattern"
};

ViewPatternButton.propTypes = {
	pattern: PropTypes.object,
	className: PropTypes.string,
	history: PropTypes.object.isRequired,
	title: PropTypes.string,
	link: PropTypes.string,
	icon: PropTypes.bool
};

export default ViewPatternButton;